import { render } from "./NewLookupValue.vue?vue&type=template&id=0686a9ea"
import script from "./NewLookupValue.vue?vue&type=script&lang=js"
export * from "./NewLookupValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__